import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=55dc8620&scoped=true"
import script from "./Sales.js?vue&type=script&lang=js&external"
export * from "./Sales.js?vue&type=script&lang=js&external"
import style0 from "./Sales.scss?vue&type=style&index=0&id=55dc8620&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dc8620",
  null
  
)

export default component.exports